module.exports = __webpack_public_path__ + "static/media/tic-ms-certs-icon.230fe28f.png";